import React, { useEffect } from "react";
import { preloadData } from "../utils/dataLoader";

/**
 * DataPreloader Component - Preloads critical data for the application
 * This component runs in the background to load essential data early
 */
const DataPreloader = ({
  preloadOnMount = true,
  criticalData = ["categories"],
  secondaryData = ["books", "reading-materials", "courses"],
  debug = false,
}) => {
  useEffect(() => {
    if (!preloadOnMount) return;

    const preloadCriticalData = async () => {
      try {
        if (debug) {
          console.log("🚀 Starting critical data preload...");
        }

        // Preload critical data first (blocking)
        await preloadData(criticalData);

        if (debug) {
          console.log("✅ Critical data preloaded:", criticalData);
        }

        // Preload secondary data in background (non-blocking)
        setTimeout(() => {
          preloadData(secondaryData)
            .then(() => {
              if (debug) {
                console.log("✅ Secondary data preloaded:", secondaryData);
              }
            })
            .catch((error) => {
              if (debug) {
                console.warn(
                  "⚠️ Some secondary data failed to preload:",
                  error,
                );
              }
            });
        }, 100); // Small delay to not block critical rendering
      } catch (error) {
        if (debug) {
          console.error("❌ Critical data preload failed:", error);
        }
      }
    };

    preloadCriticalData();
  }, [preloadOnMount, criticalData.join(","), secondaryData.join(","), debug]);

  // This component doesn't render anything
  return null;
};

export default DataPreloader;
